import styled from 'styled-components'

const WeatherCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const WeatherCardRow = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 20px;
`

const WeatherCardCol = styled.div`
  display: flex;
  flex-direction: column;
  // padding-top: 20px;
`

export { WeatherCardCol, WeatherCardContainer, WeatherCardRow }
